<div class="headline">
  <span class="mat-h1 m0">Benachrichtigungen</span>
  <span class="header-actions">
    <button (click)="openSettings()" mat-button>
      <mat-icon>settings</mat-icon>
      E-Mail-Einstellungen
    </button>
    <button (click)="markAllRead()" [disabled]="unreadCount === 0" color="primary" mat-flat-button>
      <mat-icon>done_all</mat-icon>
      Alle als gelesen markieren
    </button>
  </span>
</div>
<hr>

<div class="notification-page mat-elevation">
  <div class="filter-bar">
    <mat-button-toggle-group (change)="setUnreadOnly($event.value)" [value]="unreadOnly" aria-label="Filter">
      <mat-button-toggle [value]="false">Alle</mat-button-toggle>
      <mat-button-toggle [value]="true">Ungelesen ({{ unreadCount }})</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (loading && notifications.length === 0) {
    <div class="center-content pad16">
      <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else {
    <ul [class.reloading]="loading" class="notification-list">
      @for (notification of notifications; track notification.id) {
        <li [class.unread]="!notification.read" class="notification">
          <mat-icon class="notification-icon">{{ icon(notification) }}</mat-icon>
          <div class="notification-body">
            <span class="message">{{ notification.message }}</span>
            <span class="gray date">{{ notification.createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
          </div>
          <div class="notification-actions">
            @if (hasFolderLink(notification)) {
              <button (click)="openFolder(notification); $event.stopPropagation()" mat-button>
                Zur Sammelmappe
              </button>
            }
            @if (!notification.read) {
              <button (click)="markRead(notification); $event.stopPropagation()" aria-label="Als gelesen markieren"
                      class="action-button" mat-icon-button matTooltip="Als gelesen markieren">
                <mat-icon>mark_email_read</mat-icon>
              </button>
            }
            <button (click)="delete(notification); $event.stopPropagation()" aria-label="Löschen" class="action-button"
                    mat-icon-button matTooltip="Löschen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </li>
      } @empty {
        <li class="empty gray">
          {{ unreadOnly ? 'Keine ungelesenen Benachrichtigungen.' : 'Keine Benachrichtigungen vorhanden.' }}
        </li>
      }
    </ul>
  }

  <mat-paginator (page)="page($event)" [length]="totalElements" [pageIndex]="pageIndex"
                 [pageSizeOptions]="[20, 50, 100]" [pageSize]="pageSize" showFirstLastButtons></mat-paginator>
</div>
